import React from 'react'
import classnames from 'classnames'

import icons from '../../../assets/icons'
import {TIcon, TIconSize} from './types'

import styles from './styles.module.css'

export type ImageProps = Omit<React.SVGProps<SVGSVGElement>, 'alt' | 'src'> & {
  name: TIcon
  color?: string
  size?: TIconSize
  inline?: boolean
  src?: string
}

export function Icon({size = 'm', name, color, className, inline, ...props}: ImageProps) {
  const ICON = icons[name]

  return (
    <ICON
      className={classnames(className, styles.root, styles[size], {[styles.inline]: inline})}
      {...(color ? {style: {'--svg-color-main': color} as React.CSSProperties} : {})}
      {...props}
    />
  )
}
